module.exports = __webpack_public_path__ + "static/media/Icon-awesome-twitter.a96a2f46.svg";